export class AccountExecutives {
    Id: number;
    Name: string;
}
export class Station {
    Stationnum: number;
    StationID: number;
    StationName: number;
    StationGroupName: number;
}
export class ChaseAdvancePaymentUIDRequest {
    amount: string;
    agencyId: string;
    paymentType: string;
    transactionType: string;
    advancePaymentId: string;
}
export class ChaseUIDRequest {
    amount: string;
    paymentType: string;
    transactionType: string;
    chaseOrderId: string;
    isCreateNewProfile: any;
}

export class AdvancePaymentstationsDetails {

    advancePaymentstationsId: string;
    advancePaymentId: number;
    stationId: number;
    createdBy: number;
    amount: number;
    externalUserComments: number;
    accountExecutiveId: number;
    // Arvind Agency for Advance page
    agencyAdvance: string;

}

export class StationList {

    advancePaymentstationsId: number;
    stationId: number;
    Amount: number;
    Station: Station;
    isEditable:boolean;
}


export interface Station {
    Stationnum: number;
    StationID: number;
    StationName: number;
}

export class advancePaymentInfo
{
advancePaymentId:number;
externalUserComments: string;
accountExecutiveId:number;
sumAmount:number;
// Arvind added for agency for advance page.
agencyAdvance: any;
}
  



// WEBPACK FOOTER //
// ./src/app/external-user/Model/AdvancePayment.ts